import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';
import {
  SaveAndExitButton,
  CancelButton,
} from '@bingads-webui-react/wizard-ui-library';

export const EditFooter = ({
  saveAndExitButtonText,
  cancelButtonText,
}) => (
  <Stack horizontal tokens={{ childrenGap: 16 }}>
    <SaveAndExitButton buttonText={saveAndExitButtonText} />
    <CancelButton buttonText={cancelButtonText} />
  </Stack>
);

EditFooter.propTypes = {
  saveAndExitButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
};

EditFooter.defaultProps = {
  saveAndExitButtonText: undefined,
  cancelButtonText: undefined,
};
